import debounce from 'lodash.debounce';
import Promise from 'promise-polyfill';

/**
 * @module
 * simple polyfill to swap the currentSrc of an object-fit'ed img to be the background of it's container.
 */

const selector = '[data-js-video]';
const videoFrame = function (el, app) {

    const $el = $(el);
    const $poster = $el.find('[data-js-video-poster]');
    const $iframe = $el.find('[data-js-video-iframe]');
    const $videoNative = $el.find('[data-js-video-native]');
    const $content = $el.find('[data-js-video-content]');
    const $play = $el.find('[data-js-video-play]');
    const $allyOpen = $el.find('[data-js-video-ally-open]');
    const $allyClose = $el.find('[data-js-video-ally-close]');
    const autoplay = $el.attr('data-js-video-autoplay') === 'true';

    const modes = {
        iframe: 'Iframe',
        native: 'Native'
    }

    const mode = $iframe.length ? modes.iframe : modes.native;

    let status = false;
    const duration = 300;
    let playWidth = 0;
    // let   playMargin = 0;
    let posterWidth = 0;
    let posterHeight = 0;
    let viewportWidth = window.innerWidth || document.documentElement.clientWidth || $(window).width();
    let viewportWidthPrev = viewportWidth;

    const init = function () {
        measure();
        setButtonTransition();
        registerEvents();
        // set up the resize event
        onResize();
        if (mode === modes.iframe) {
            $iframe.attr('aria-hidden', true);
        }
        else if (mode === modes.native) {
            $videoNative.attr('aria-hidden', true);

            // Event listener for video native. Used by the native video player to start playing when at least one package and metadata come through
            $videoNative.on('canplay', function (e) {
                //this.play();
            });

            const vn = $videoNative[0];
            vn.onerror = function () {
                console.log("Video error " + vn[0].onerror.code + "; details: " + vn[0].onerror.message);
            };
        }

        if (autoplay) {
            play( {mute: true });
        }
    };

    const measure = function () {
        playWidth = $play[0].offsetWidth;
        // var computedStyle = window.getComputedStyle($play[0]);
        // playMargin = parseInt(computedStyle.marginRight);
        posterWidth = $poster[0].offsetWidth;
        posterHeight = $poster[0].offsetHeight;
    }

    const setButtonTransition = function () {
        const playEndWidth = 40;
        const transformScale = playEndWidth / playWidth;
        const transformX = (posterWidth - playEndWidth) - ((posterWidth / 2) - (playWidth / 2)) - playEndWidth - 12;
        const transformY = (posterHeight - playEndWidth) - ((posterHeight / 2) - (playWidth / 2)) - playEndWidth - 12;
        const transform = 'translateX(' + transformX + 'px) translateY(-' + transformY + 'px) scale(' + transformScale + ') rotate(90deg)';
        // store the transform
        $play.attr('data-js-transform', transform);
    }

    const registerEvents = function () {
        $poster.on('click', playStop);
        $play.on('click', playStop);
    };

    const playStop = function (ev) {
        ev.preventDefault();
        if (!status) {
            play( { mute: false });
        } else {
            stop();
        }
    };

    const play = function ( { mute } ) {

        $poster.addClass('Ge-Video-Poster--active').attr('tabindex', '-1');
        $el.addClass('Ge-Video--active');
        let src = $poster.attr('data-js-video-src');

        if (mode === modes.iframe) {
            $iframe.attr('aria-hidden', false);
            $iframe.addClass('Ge-Video-Iframe--active');
            if (mute) {
                src += "&mute=1";
            }
            $iframe.attr('src', src);
        }
        else if (mode === modes.native) {
            $videoNative.attr('aria-hidden', false);
            $videoNative.prop('autoplay', true);
            if( mute ){
                $videoNative.prop('muted', true);
            }
            else {
                $videoNative.removeAttr("muted");
            }
            $videoNative.addClass('Ge-Video-Native--active');
            const $videoNativeSrc = $videoNative.find('[data-js-video-native-src]');
            $($videoNativeSrc[0]).attr('src', src);
            // add the classes that control the transition
        }

        // add the classes that control the transition
        $play.addClass('Ge-Video-Play--play-stop');
        // set transition going
        playToStop();
        status = true;
        // remove the transition classes once done
        setTimeout(function playTimer() {
            $play.removeClass('Ge-Video-Play--play-stop').attr('tabindex', '0');
            $allyOpen.hide();
            $allyClose.show();
        }, duration);

    };

    const playToStop = function () {
        const styleCore = 'transform: ' + $play.attr('data-js-transform');
        $play.addClass('Ge-Video-Play--active').attr('style', styleCore);
        $allyOpen.show();
        $allyClose.hide();
        if (mode === modes.native) {
            $videoNative[0].load();
        }
    };

    const stop = function () {

        $el.removeClass('Ge-Video--active');
        $poster.removeClass('Ge-Video-Poster--active').attr('tabindex', '0');

        if (mode === modes.iframe) {
            $iframe.attr('aria-hidden', true);
            $iframe.removeClass('Ge-Video-Iframe--active');
        }
        else if (mode === modes.native) {
            $videoNative.attr('aria-hidden', true);
            $videoNative.removeClass('Ge-Video-Native--active');
        }
        $play
            .addClass('Ge-Video-Play--play-stop')
            .removeClass('Ge-Video-Play--active')
            .attr('style', '')
            .attr('tabindex', '-1');

        // when the transition is complete, remove the iFrame src.
        setTimeout(function stopTimer() {
            if (mode === modes.iframe) {
                $iframe[0].src = '';
            }
            else if (mode === modes.native) {
                const $videoNativeSrc = $videoNative.find('[data-js-video-native-src]');
                if ($videoNativeSrc.length) {
                    // We must call .pause() here since the audio html5 video bug will kick in in .stop()
                    $videoNative[0].pause();
                }
            }
            status = false;
            // remove the transition classes once done
            $play.removeClass('Ge-Video-Play--play-stop');
        }, duration);
    };

    const onResizeMeasurePlay = function () {
        return new Promise(function measuringPlay1Promise(resolve, reject) {
            $play.attr('style', 'transition:all 0ms');
            measure();
            if ($play.hasClass('Ge-Video-Play--active')) {
                resolve(true);
            } else {
                resolve(false);
            }
        })
    }

    // things need to be re-positioned when the window is resized
    const onResize = function () {

        let timer = false;

        const onResizeThrottled = function () {
            onResizeMeasurePlay().then(function (wasActive) {
                setButtonTransition();
                // if the play button was active, reset it after the measurements
                if (wasActive) {
                    playToStop();
                }
                $el.removeClass('Ge-Video--resizing');
            });
        };

        // throttle resize events
        $(window).resize(function onResizeUnThrottled(ev) {
            // Don't trigger resize on vertical resize (mobile OS' do this all the time just on scroll).
            // Note that we try and do every kind of "soft" measurement before we attempt to recalc styles (which is costly in FPS)
            viewportWidth = ev.target.innerWidth || window.innerWidth || document.documentElement.clientWidth || $(window).width();
            if (viewportWidth != viewportWidthPrev) {
                $el.addClass('Ge-Video--resizing');
                debounce(onResizeThrottled, 500, { 'leading': false })();
            }
            viewportWidthPrev = viewportWidth;
        });

    };

    return {
        init: init()
    };
};

videoFrame.selector = selector;

export default videoFrame;
